import { createAction } from 'redux-actions';
import { createRoutine } from 'redux-saga-routines';
import { GET_STAFF, UPDATE_STAFF, SET_LOCATION } from './type';

export const getStaff = createRoutine(GET_STAFF);
export const updateStaff = createAction(UPDATE_STAFF);
export const setLocation = createAction(SET_LOCATION);
